import { useAppStore } from '../store/appStore';
import { Button, Card, Table } from 'antd';
import type { Zone } from '../types/zones';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

const ZonesPage = () => {
  const zones = useAppStore((state) => state.zones);

  const columns: ColumnsType<Zone> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text) => text || '-',
    },
    {
      title: 'Plant',
      dataIndex: ['plant', 'name'],
      key: 'plant',
      sorter: (a, b) => a.plant.name.localeCompare(b.plant.name),
    },
    {
      title: 'Panels',
      dataIndex: 'panels',
      key: 'panels',
      render: (panels) => (
        <Button
          type="link"
          className="!text-[#fc4c02]"
          onClick={() => console.log('View panels:', panels)}
        >
          View
        </Button>
      ),
    },
    {
      title: 'Anchors',
      dataIndex: 'anchors',
      key: 'anchors',
      render: (panels) => (
        <Button
          type="link"
          className="!text-[#fc4c02]"
          onClick={() => console.log('View panels:', panels)}
        >
          View
        </Button>
      ),
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (date) => dayjs(date).format('DD-MM-YYYY'),
      sorter: (a, b) => dayjs(a.updatedAt).unix() - dayjs(b.updatedAt).unix(),
    },
  ];

  return (
    <Card className="p-6">
      <Table
        columns={columns}
        dataSource={zones}
        rowKey="id"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} zones`,
        }}
      />
    </Card>
  );
};

export default ZonesPage;
